import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DateFormatPipe, DateTimeFormatPipe, TimeFormatPipe, SentenceWithUnderscoreTitleCase } from './customDatePipes';


@NgModule({
  declarations: [
    DateFormatPipe,
    DateTimeFormatPipe,
    SentenceWithUnderscoreTitleCase,
    TimeFormatPipe,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    DateFormatPipe,
    DateTimeFormatPipe,
    SentenceWithUnderscoreTitleCase,
    TimeFormatPipe,
  ]
})
export class SharedComponentsModule { 
  static forRoot() {
    return {
      ngModule: SharedComponentsModule,
      providers: []
    };
  }
}
